enum EstimateStatus {
  Draft = 0,
  Wip = 1,
  Completed = 10,
  Canceled = -1,
}

const EstimateStatusObj: any = {};
EstimateStatusObj[EstimateStatus.Draft] = {
  value: EstimateStatus.Draft,
  title: 'Rascunho',
};
EstimateStatusObj[EstimateStatus.Wip] = {
  value: EstimateStatus.Wip,
  title: 'Em Andamento',
};
EstimateStatusObj[EstimateStatus.Completed] = {
  value: EstimateStatus.Completed,
  title: 'Concluído',
};
EstimateStatusObj[EstimateStatus.Canceled] = {
  value: EstimateStatus.Canceled,
  title: 'Cancelado',
};

export { EstimateStatusObj };

export default EstimateStatus;
